/** JSON-safe, kanoniczna reprezentacja nieujemnej liczby monet. */
export type Coins = string;

export type CoinInput = Coins | bigint | number;

const UNSIGNED_INTEGER = /^(?:0|[1-9]\d*)$/;

/** Normalizuje wartość do decimal string; odrzuca nieprecyzyjne JS numbers. */
export function toCoins(value: CoinInput): Coins {
  if (typeof value === 'bigint') {
    if (value < 0n) throw new RangeError('Coins cannot be negative');
    return value.toString();
  }
  if (typeof value === 'number') {
    if (!Number.isSafeInteger(value) || value < 0) {
      throw new RangeError(`Unsafe coin number: ${String(value)}`);
    }
    return String(value);
  }
  if (!UNSIGNED_INTEGER.test(value)) {
    throw new RangeError(`Invalid coin string: ${value}`);
  }
  return value;
}

export function coinsBigInt(value: CoinInput): bigint {
  return BigInt(toCoins(value));
}

export function addCoins(current: CoinInput, add: CoinInput): Coins {
  return (coinsBigInt(current) + coinsBigInt(add)).toString();
}

export function subtractCoins(current: CoinInput, cost: CoinInput): Coins | null {
  const balance = coinsBigInt(current);
  const debit = coinsBigInt(cost);
  return balance < debit ? null : (balance - debit).toString();
}

export function hasCoins(current: CoinInput, cost: CoinInput): boolean {
  return coinsBigInt(current) >= coinsBigInt(cost);
}

export function coinsAreZero(value: CoinInput): boolean {
  return coinsBigInt(value) === 0n;
}
